export enum ButtonType {
    Main = "main",
    MinorRed = "minor red",
    MinorWhite = "minor white",
}